const ArrowLonRightIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      className='dark:child:stroke-primary-500'
      d='M14.375 6.875L17.5 10M17.5 10L14.375 13.125M17.5 10H2.5'
      stroke='#ffff'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default ArrowLonRightIcon;
